<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-toolbar flat dense height="90">
      <v-btn
        v-if="getPermission('stores.create')"
        color="secondary"
        class="text-capitalize px-5"
        depressed
        v-text="translations.addStore[lang]"
        @click="open(1, {})"
      ></v-btn>

      <v-spacer></v-spacer>

      <v-btn
        color="secondary"
        class="text-capitalize px-5 mr-3"
        depressed
        v-text="translations.visibleColumns[lang]"
        @click="columnsDialog = true"
      ></v-btn>

      <v-btn
        v-if="getPermission('stores.update')"
        color="secondary"
        class="text-capitalize px-5"
        depressed
        v-text="translations.rights[lang]"
        @click="openPermissionsDialog('default', {})"
      ></v-btn>
    </v-toolbar>

    <v-row no-gutters justify="end" class="px-4 pb-3 align-end">
      <div class="mr-auto">
        <ExportLinks export-key="company-stores" :filters="filtersData" />
      </div>
      <v-col cols="4">
        <v-col cols="12" sm="10" class="pa-0">
          <b-select
            :items="statuses"
            v-model="status"
            :label="translations.status[lang]"
          ></b-select>
        </v-col>
      </v-col>
      <v-col cols="4">
        <!-- <b-search-field
                    v-model="search"
                    :search-types="searchTypes"
                    :selected-search-type="selectedSearchType"
                ></b-search-field> -->
        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="stores"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="serverItemsLength"
      :loading="loading"
      disable-sort
      class="b-outlined"
    >
      <template v-slot:item.store_code="{ item }">
        {{ item.store_code ? item.store_code : '-' }}
      </template>
      <template v-slot:item.view="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="
                () => {
                  store = item;
                  infoDialog = true;
                }
              "
            >
              <v-icon v-text="icons.mdiEye"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.showAdditionalInfo[lang]"></span>
        </v-tooltip>
      </template>
      <template v-slot:item.store_id="{ item }"> # {{ item.store_id }} </template>
      <template v-slot:item.show_on_map="{ item }">
        <v-switch
          v-model="item.show_on_map"
          color="success"
          @change="toggleTableValue('show_on_map', item.show_on_map, item)"
          hide-details
        ></v-switch>
      </template>

      <template v-slot:item.online_payment_processing="{ item }">
        <v-switch
          v-model="item.online_payment_processing"
          color="success"
          @change="
            toggleTableValue('online_payment_processing', item.online_payment_processing, item)
          "
          hide-details
        ></v-switch>
      </template>

      <template v-slot:item.active="{ item }">
        <v-switch
          v-model="item.active"
          color="success"
          @change="toggleTableValue('active', item.active, item)"
          hide-details
        ></v-switch>
      </template>

      <template v-slot:item.last_transaction_date="{ item }">
        <!-- {{ item.last_transaction_date&&item.last_transaction_date.substring(0,10) || '' }} -->
        {{
          (item.last_transaction_date &&
            new Date(item.last_transaction_date).toLocaleDateString(dateLang, dateOptions)) ||
          ''
        }}
      </template>

      <template v-slot:item.pos_points_delivery="{ item }">
        <v-switch
          v-model="item.pos_points_delivery"
          color="success"
          @change="toggleTableValue('pos_points_delivery', item.pos_points_delivery, item)"
          hide-details
        ></v-switch>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip v-if="getPermission('stores.admin_panel')" color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              color="secondary"
              icon
              v-on="on"
              @click="
                () => {
                  store = item;
                  redirectDialog = true;
                }
              "
            >
              <v-icon v-text="icons.mdiOpenInNew"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.redirect[lang]"></span>
        </v-tooltip>

        <v-tooltip v-if="getPermission('stores.update')" color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on" @click="openPermissionsDialog('store', item)">
              <v-icon v-text="icons.mdiClipboardEditOutline"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.updatePermissions[lang]"></span>
        </v-tooltip>

        <v-tooltip v-if="getPermission('stores.update')" color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn color="yellow darken-3" icon v-on="on" @click="open(2, item)">
              <v-icon v-text="icons.mdiPencilOutline"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.update[lang]"></span>
        </v-tooltip>

        <v-tooltip v-if="getPermission('stores.delete')" color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              color="red"
              icon
              v-on="on"
              @click="
                () => {
                  store = item;
                  deleteDialog = true;
                }
              "
            >
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600">
      <StoreForm :mode="mode" :query="query" @cancel="dialog = false" />
    </v-dialog>

    <v-dialog v-model="rightsDialog" max-width="500">
      <RightsForm
        @cancel="rightsDialog = false"
        :mode="rightsMode"
        :store-id="permissionDialogStoreId"
      />
    </v-dialog>

    <v-dialog v-model="infoDialog" max-width="500">
      <AdditionalInfo @cancel="infoDialog = false" />
    </v-dialog>

    <v-dialog v-model="redirectDialog" max-width="500">
      <b-card
        title="Verification"
        :submit-text="{ el: 'Ναι', en: 'Yes', it: 'Si' }"
        :loading="loading"
        @cancel="redirectDialog = false"
        @submit="redirect"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          {{ translations.redirectMessageFirst[lang] }}
          <span class="font-weight-bold">{{ store.name }}</span
          >.
        </div>

        <div class="subtitle-1 font-weight-medium pl-2">
          {{ translations.redirectMessageSecond[lang] }} ?
        </div>
      </b-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <b-card
        type="delete"
        title="Delete Store"
        :loading="loading"
        :error-message="errorMessage"
        :submit-text="{ el: '', en: 'delete', it: '' }"
        @cancel="deleteDialog = false"
        @submit="remove"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          Are you sure you want to delete
          <span class="font-weight-bold text--primary">{{ store.name }}</span
          >?
        </div>
      </b-card>
    </v-dialog>

    <v-dialog v-model="columnsDialog" max-width="500">
      <b-card
        :title="translations.visibleColumns[lang]"
        :cancel-text="{ el: 'Κλείσιμο', en: 'close', it: 'Chiudi' }"
        @cancel="closeColumnsModal()"
        :submitBtn="false"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          <v-checkbox
            v-for="(header, index) in headersData"
            :key="index"
            color="secondary"
            class="mt-3 pt-0"
            hide-details
            v-model="header.visible"
          >
            <template v-slot:label>
              <h4 class="subtitle-2">
                {{ translations[header.translationKey][lang] }}
              </h4>
            </template>
          </v-checkbox>
        </div>
      </b-card>
    </v-dialog>
  </v-tab-item>
</template>

<script>
import {
  mdiEye,
  mdiPencilOutline,
  mdiOpenInNew,
  mdiClipboardEditOutline,
  mdiClose,
  mdiCheckCircleOutline,
  mdiMinusCircleOutline,
} from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import StoreForm from '@/components/loyaltyPanel/stores/StoreForm.vue';
import RightsForm from '@/components/loyaltyPanel/stores/RightsForm.vue';
import AdditionalInfo from '@/components/loyaltyPanel/stores/AdditionalInfo.vue';
import translations from '@/utils/translations/loyaltyPanel/stores/storesTab';
import ExportLinks from '@/components/general/ExportLinks.vue';

export default {
  name: 'StoresTab',

  components: { StoreForm, RightsForm, AdditionalInfo, ExportLinks },

  mixins: [translations],

  data() {
    return {
      icons: {
        mdiEye,
        mdiPencilOutline,
        mdiClipboardEditOutline,
        mdiOpenInNew,
        mdiClose,
        mdiCheckCircleOutline,
        mdiMinusCircleOutline,
      },
      searchTypes: [
        'All Fields',
        'Name',
        'Name of Store(in app)',
        'Banks',
        'Address',
        'Phone',
        'Registration Date',
        '+10 days without transaction',
      ],

      status: '',
      selectedSearchType: 'All Fields',
      page: +this.$route.query.page,
      mode: 0,
      rightsMode: '',
      permissionDialogStoreId: null,
      search: '',
      infoDialog: false,
      redirectDialog: false,
      columnsDialog: false,
      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },
      headersData: [
        {
          translationKey: 'id',
          value: 'store_id',
          width: 90,
          visible: true,
        },
        {
          translationKey: 'code',
          value: 'store_code',
          visible: true,
        },
        {
          translationKey: 'name',
          value: 'name',
          width: 200,
          visible: true,
        },
        {
          translationKey: 'storeName',
          value: 'app_name',
          width: 200,
          visible: true,
        },
        {
          translationKey: 'map',
          value: 'show_on_map',
          visible: true,
        },
        {
          translationKey: 'payments',
          value: 'online_payment_processing',
          visible: true,
        },
        {
          translationKey: 'active',
          value: 'active',
          visible: true,
        },

        {
          translationKey: 'pos',
          value: 'pos_points_delivery',
          visible: true,
        },
        {
          translationKey: 'lastTransaction',
          value: 'last_transaction_date',
          visible: true,
        },
        {
          translationKey: 'actions',
          value: 'actions',
          width: 200,
          visible: true,
        },
      ],
      permissoinsDialog: false,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),
    ...mapState('loyaltyPanel/stores/storesTab', ['stores']),

    lang() {
      return this.$route.params.lang;
    },

    filtersData() {
      let filters = {
        q: this.search || null,
      };
      if (this.status === 'days-without-transaction') {
        filters['days-without-transaction'] = 10;
      }
      return filters;
    },

    dateLang() {
      let lang = 'en-US';
      if (this.lang === 'el') {
        lang = 'el-GR';
      } else if (this.lang === 'it') {
        lang = 'it-IT';
      }
      return lang;
    },

    headers() {
      const result = [];
      this.headersData.forEach((header) => {
        if (header.visible) {
          if (header.width) {
            result.push({
              text: this.translations[header.translationKey][this.lang],
              value: header.value,
              width: header.width,
            });
          } else {
            result.push({
              text: this.translations[header.translationKey][this.lang],
              value: header.value,
            });
          }
        }
      });
      return result;
    },

    dialog: {
      get() {
        return this.$store.state.dialog;
      },

      set(val) {
        this.setDialog(val);
      },
    },

    rightsDialog: {
      get() {
        return this.$store.state.loyaltyPanel.stores.storesTab.rightsDialog;
      },

      set(val) {
        this.setRightsDialog(val);
      },
    },

    deleteDialog: {
      get() {
        return this.$store.state.deleteDialog;
      },

      set(val) {
        this.setDeleteDialog(val);
      },
    },

    store: {
      get() {
        return this.$store.state.loyaltyPanel.stores.storesTab.store;
      },

      set(val) {
        this.setItem(val);
      },
    },

    userDetails: {
      get() {
        return this.$store.state.loyaltyPanel.stores.storesTab.userDetails;
      },

      set(val) {
        this.setUserDetails(val);
      },
    },
    statuses() {
      return [
        {
          text: this.translations.all[this.lang],
          value: '',
        },
        {
          text: '+10 ' + this.translations.daysWithoutTransaction[this.lang],
          value: 'days-without-transaction',
        },
      ];
    },
    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }
      if (this.status === 'days-without-transaction') {
        return query + 'days-without-transaction=10';
      }
      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapMutations([
      'setLoading',
      'setStoreId',
      'setDialog',
      'setDeleteDialog',
      'setResetSuccess',
      'setResetValidation',
    ]),
    ...mapMutations('loyaltyPanel/stores/storesTab', [
      'setItem',
      'setUserDetails',
      'setRightsDialog',
      'setPermissions',
    ]),
    ...mapActions(['getUser', 'getPermission']),
    ...mapActions('loyaltyPanel/stores/storesTab', [
      'getItems',
      'remove',
      'getStorePermissions',
      'toggleStoreValue',
      'getStoresDefaultPermissions',
    ]),
    ...mapActions('storePanel', ['getStore']),

    open(mode, item, userDetails) {
      this.mode = mode;
      this.store = item;
      this.userDetails = userDetails;
      setTimeout(() => this.setResetSuccess(true), 300);
      this.setResetValidation(true);
      this.dialog = true;
    },

    async openPermissionsDialog(mode, item) {
      this.setPermissions({});
      this.rightsMode = mode;
      this.permissionDialogStoreId = item.store_id || null;
      this.rightsDialog = true;
      if (mode != 'default') {
        let res = await this.getStorePermissions(item.store_id);
        if (res.error) {
          this.rightsDialog = false;
        }
      }
    },

    // redirect() {
    //     this.$router.push({
    //         name: "UserStores",
    //         params: { storeName: this.store.name },
    //     });
    // },
    async redirect() {
      try {
        localStorage.setItem('storeId', this.store.store_id);
        this.setStoreId(this.store.store_id);
        await this.getStore();
        await this.getUser(this.store.store_id);
        this.$router.push(`/${this.lang}/storePanel`);
        this.setLoading(false);
      } catch (ex) {
        this.setLoading(false);

        console.log(ex);
      }
    },
    handleSearch() {
      let params = this.query;
      if (this.search) {
        params += `&q=${this.search}`;
      }
      this.getItems(params);
    },

    toggleTableValue(key, val, item) {
      item[key] = val;
      const body = {
        store_id: item.store_id,
        payload: {
          active: item.active,
          online_payment_processing: item.online_payment_processing,
          show_on_map: item.show_on_map,
          pos_points_delivery: item.pos_points_delivery == true,
        },
      };
      this.toggleStoreValue(body);
    },

    closeColumnsModal() {
      this.columnsDialog = false;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.setResetSuccess(false);
        this.setResetValidation(false);
      }
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.debouncedSearch();
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      // if (val == null) {
      //     this.getItems(this.query);
      // } else {
      this.debouncedSearch();
      // }
    },
    status(val) {
      this.debouncedSearch();
    },

    headersData: {
      deep: true,
      handler(val) {
        const visibleHeaders = [];
        val.forEach((header) => {
          if (header.visible) {
            visibleHeaders.push(header);
          }
        });
        localStorage.setItem('companyStoresColumns', JSON.stringify(visibleHeaders));
      },
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  mounted() {
    const columns = JSON.parse(localStorage.getItem('companyStoresColumns'));
    if (columns) {
      const columnsValues = columns.map((column) => column.value);

      this.headersData.forEach((header) => {
        if (columnsValues.includes(header.value)) {
          header.visible = true;
        } else {
          header.visible = false;
        }
      });
    }
    this.getItems(this.query);
    this.getStoresDefaultPermissions();
  },
};
</script>
<style lang="scss">
.pointer {
  cursor: pointer;
}
</style>
